import { getGenericStore } from './genericStore';

const brickId2EditStore = Object.create(getGenericStore());
export default brickId2EditStore;